import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faArrowRight } from '@fortawesome/free-solid-svg-icons';

const RelatedPosts = ({ posts }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  if (!posts || posts.length === 0) {
    return (
      <div className="related-posts">
        <h3 className="related-posts__title">Related Posts</h3>
        <div className="related-posts__empty">
          <p>No related posts found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="related-posts">
      <h3 className="related-posts__title">Related Posts</h3>
      
      <div className="related-posts__list">
        {posts.slice(0, 3).map((post) => (
          <article key={post.id} className="related-post-card">
            <div className="related-post-card__image-container">
              {post.main_image_url ? (
                <img 
                  src={post.main_image_url} 
                  alt={post.title}
                  className="related-post-card__image"
                />
              ) : (
                <div className="related-post-card__image-placeholder">
                  <FontAwesomeIcon icon={faArrowRight} />
                </div>
              )}
            </div>
            
            <div className="related-post-card__content">
              <div className="related-post-card__meta">
                <div className="related-post-card__date">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                  {formatDate(post.published_at)}
                </div>
              </div>
              
              <h4 className="related-post-card__title">
                <Link to={`/blog/${post.slug}`}>
                  {post.title.length > 60 
                    ? `${post.title.substring(0, 60)}...` 
                    : post.title
                  }
                </Link>
              </h4>
              
              {null}
            </div>
          </article>
        ))}
      </div>
      
      <div className="related-posts__more">
        <Link to="/blog" className="related-posts__more-link">
          View All Posts
          <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>
    </div>
  );
};

export default RelatedPosts; 